// «Встановити застосунок»: holds the browser's beforeinstallprompt event until
// the student asks. Browsers without the event (Safari, Firefox) and an already
// installed app never fire it, so install simply stays unavailable there.
export const createInstallPrompt = () => {
    let deferred = null;
    const listeners = new Set();
    const set = (event) => {
        deferred = event;
        listeners.forEach((listener) => listener());
    };

    return {
        /** Before the app chunk loads: the event may fire while it downloads. */
        capture: (target) => {
            target.addEventListener('beforeinstallprompt', (event) => {
                // Our menu item replaces the browser's own install banner.
                event.preventDefault();
                set(event);
            });
            target.addEventListener('appinstalled', () => set(null));
        },
        subscribe: (listener) => {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
        isAvailable: () => deferred !== null,
        /** In the click handler (needs a user gesture). An event works only once. */
        prompt: () => {
            const event = deferred;
            if (!event) return Promise.resolve();
            set(null);
            return Promise.resolve(event.prompt()).catch(() => {
                // Not shown this time; the browser fires the event again later.
            });
        },
    };
};

export const installPrompt = createInstallPrompt();
